import {PassengersTab} from "../../../defaultFlow/index.js"

export default class PassengersTabDayTour extends PassengersTab {
  constructor (options) {
    super(options)
  }
}